import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'app-file',
    templateUrl: './file.component.html',
    styleUrls: ['./file.component.scss']
})
export class FileComponent {
    @Output('saveFiles')output = new EventEmitter();
    @Input('fileUpload') fileUpload?: string;
    @ViewChild('file') input;
    public files: Set<File> = new Set();
    progress = false;
    canBeClosed = true;
    showCancelButton = true;
    uploading = false;
    uploadSuccessful = false;
    progressValue = 0;

    constructor() {}
    //despliega ventana para agregar archivo
    addFile() {
        this.input.nativeElement.click();
    }
    //al agregarse archivo se toma del input el archivo a guardar
    loadFile() {
        const files: { [key: string]: File } = this.input.nativeElement.files;
        for (let key in files) {
            if (!isNaN(parseInt(key))) {
                this.files.add(files[key]);
            }
        }
        this.save();
    }
    delete(file) {
        this.input.nativeElement.value = '';
        this.files.delete(file);
        this.uploading = false;
        this.output.emit(null);
        this.progressValue = 0;
    }
    save() {
        setTimeout(() => this.progressValue = 100, 500)
        this.progress = true;
        // set the component state to 'uploading'
        this.uploading = true;

        this.output.emit(this.files);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/file/file.component.ts